import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    this.timer = window.setTimeout(() => this.element.remove(), this.timeoutValue)
  }

  dismiss(event) {
    event.preventDefault()
    this.element.remove()
  }

  disconnect() {
    if (this.timer) window.clearTimeout(this.timer)
  }
}
